const plugin = require('tailwindcss/plugin');

/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './pages/**/*.{js,ts,jsx,tsx,mdx}',
    './components/**/*.{js,ts,jsx,tsx,mdx}',
    './app/**/*.{js,ts,jsx,tsx,mdx}',
  ],
  theme: {
    extend: {
      // fontFamily: {
      //   montserrat: ['var(--font-montserrat)'],
      // },
      backgroundImage: {
        'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
        'gradient-conic': 'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))',
      },
      colors: {
        'backgroundcolor':                      'var(--backgroundcolor)',
        'navbartext':                           'var(--navbartext)',
        'maincolor':                            'var(--color-main)',
        'maincolortrans':                       '#2331424d',
        'secondary':                            'var(--color-secondary)',
        'third':                                'var(--thirdcolor)',
        'price':                                'var(--color-price)',
        'forth':                                'var(--fourthcolor)',
        'light':                                'white',
        'navlight':                             '#D3D3D3',
        'mainhover':                            'var(--thirdcolor)',
        'layover':                              'var(--layovercolor)',
        'content':                              'var(--textcolor)',
        'label':                                'var(--labelcolor)',
        'labelhighlight':                       'var(--labelhighlightcolor)',
        'icon':                                 'var(--iconcolor)',
        'language-selector-color':             'var(--navbar-text-color)',
        'language-selector-color-transparent': 'var(--navbar-text-color-transparent)',
      },
      backgroundColor: ['hover'],
    },
  },
  plugins: [
    plugin(function ({ addComponents, addBase, theme }) {

      // ── Base: element-level defaults only ──────────────────────────────────────
      // addBase({
      //   // 'html': { fontFamily: theme('fontFamily.montserrat') },
      //   'h1': {
      //     // fontFamily: theme('fontFamily.montserrat'),
      //     color: theme('colors.maincolor'),
      //     letterSpacing: theme('letterSpacing.wide'),
      //   },
      //   'h2': {
      //     // fontFamily: theme('fontFamily.montserrat'),
      //     color: theme('colors.maincolor'),
      //     letterSpacing: theme('letterSpacing.wide'),
      //   },
      //   // 'strong': { fontFamily: theme('fontFamily.montserrat') },
      //   // 'nav':    { fontFamily: theme('fontFamily.montserrat'), letterSpacing: theme('letterSpacing.wide') },
      //   // 'p':      { fontFamily: theme('fontFamily.montserrat'), color: theme('colors.secondary') },
      // })

      // ── Components: utility classes ────────────────────────────────────────────
      addComponents({

        // Layout
        '.container-wide': {
          maxWidth: '1600px',
          marginInline: 'auto',
          '@screen 2xl': { width: 'var(--base-width)' },
        },

        // ── Carousel labels ────────────────────────────────────────────────────
        '.label': {
          position: 'absolute',
          top: 'var(--label-top)',
          bottom: 'var(--label-bottom)',
          left: 'var(--label-left)',
          right: 'var(--label-right)',
          transform: 'var(--label-transform)',
          backgroundColor: 'var(--label-bg)',
          color: 'var(--label-text)',
          fontSize: 'var(--label-size)',
          paddingLeft: 'var(--label-padding-x)',
          paddingRight: 'var(--label-padding-x)',
          paddingTop: 'var(--label-padding-y)',
          paddingBottom: 'var(--label-padding-y)',
          borderRadius: 'var(--label-radius)',
          fontWeight: 'var(--label-fw)',
          zIndex: 10,
        },
        '.label-highlight': {
          position: 'absolute',
          top: 'var(--label-highlight-top)',
          bottom: 'var(--label-highlight-bottom)',
          left: 'var(--label-highlight-left)',
          right: 'var(--label-highlight-right)',
          transform: 'var(--label-highlight-transform)',
          backgroundColor: 'var(--label-highlight-bg)',
          color: 'var(--label-highlight-text)',
          fontSize: 'var(--label-highlight-size)',
          paddingLeft: 'var(--label-highlight-padding-x)',
          paddingRight: 'var(--label-highlight-padding-x)',
          paddingTop: 'var(--label-highlight-padding-y)',
          paddingBottom: 'var(--label-highlight-padding-y)',
          borderRadius: 'var(--label-highlight-radius)',
          fontWeight: 'var(--label-highlight-fw)',
          zIndex: 10,
        },

        // ── Carousel section ───────────────────────────────────────────────────
        '.carousel-wrapper': {
          marginTop:        'var(--carousel-section-margin)',
          marginBottom:     'var(--carousel-section-margin)',
          paddingTop:       'var(--carousel-section-padding)',
          paddingBottom:    'var(--carousel-section-padding)',
          borderBottomWidth:'var(--carousel-section-divider)',
          borderBottomColor:'var(--carousel-section-dicider-color)',
        },
        '.carousel-title-align': {
          textAlign:    'var(--carousel-title-align)',
          paddingBottom:'var(--carousel-title-padding)',
          color:        'var(--carousel-title-color)',
          fontSize:     'var(--carousel-title-size)',
          fontWeight:   'var(--carousel-title-fw)',
        },
        '.carousel-description-align': {
          textAlign:    'var(--carousel-description-align)',
          paddingBottom:'var(--carousel-description-padding)',
          color:        'var(--carousel-description-color)',
          fontSize:     'var(--carousel-description-size)',
          fontWeight:   'var(--carousel-description-fw)',
        },

        // ── Property card ──────────────────────────────────────────────────────
        '.property-image-container': {
          position:    'var(--property-image-container-position)',
          aspectRatio: 'var(--property-image-container-aspect-ratio)',
          borderRadius:'var(--property-image-container-border-radius)',
          overflow:    'hidden',
        },
        '.property-card-title': {
          color:      'var(--property-card-title-color)',
          fontSize:   'var(--property-card-title-size)',
          fontWeight: 'var(--property-card-title-fw)',
        },
        '.property-card-wrapper': {
          overflow:        'hidden',
          backgroundColor: 'var(--property-card-background)',
          borderRadius:    'var(--property-card-radius)',
          borderColor:     'var(--property-card-border-color)',
          borderWidth:     'var(--property-card-border-width)',
          boxShadow:       'var(--property-card-shadow)',
        },
        '.property-card-content':  { padding: 'var(--property-card-content-padding)' },
        '.property-location-text': { color:   'var(--property-card-location-color)' },

        // ── Project card ───────────────────────────────────────────────────────
        '.project-image-container': {
          position:    'var(--project-image-container-position)',
          aspectRatio: 'var(--project-image-container-aspect-ratio)',
          borderRadius:'var(--project-image-container-border-radius)',
          overflow:    'hidden',
        },
        '.project-card-title': {
          color:      'var(--project-card-title-color)',
          fontSize:   'var(--project-card-title-size)',
          fontWeight: 'var(--project-card-title-fw)',
        },
        '.project-card-wrapper': {
          overflow:        'hidden',
          backgroundColor: 'var(--project-card-background)',
          borderRadius:    'var(--project-card-radius)',
          borderColor:     'var(--project-card-border-color)',
          borderWidth:     'var(--project-card-border-width)',
          boxShadow:       'var(--project-card-shadow)',
        },
        '.project-card-content':  { padding: 'var(--project-card-content-padding)' },
        '.project-location-text': { color:   'var(--project-card-location-color)' },

        // ── Navbar ─────────────────────────────────────────────────────────────
        '.navbar-bg': {
          background:    'var(--navbar-background)',
          paddingTop:    'var(--navbar-padding-y)',
          paddingBottom: 'var(--navbar-padding-y)',
        },
        '.navbar-bg-transparent': {
          background:    'var(--navbar-background-transparent)',
          paddingTop:    'var(--navbar-padding-y)',
          paddingBottom: 'var(--navbar-padding-y)',
        },

        // Desktop nav links
        '.navbartext': {
          color:       'var(--navbar-text-color)',
          fontSize:    'var(--navbar-text-size)',
          fontWeight:  'var(--navbar-text-fw)',
          marginRight: 'var(--navbar-text-spacing)',
        },
        '.navbartext-transparent': {
          color:       'var(--navbar-text-color-transparent)',
          fontSize:    'var(--navbar-text-size)',
          fontWeight:  'var(--navbar-text-fw)',
          marginRight: 'var(--navbar-text-spacing)',
        },
        '.navbartext-hover': {
          color:       'var(--navbar-text-hover)',
          fontSize:    'var(--navbar-text-size)',
          fontWeight:  'var(--navbar-text-fw)',
          marginRight: 'var(--navbar-text-spacing)',
        },
        '.navbartext-transparent-hover': {
          color:       'var(--navbar-text-hover-transparent)',
          fontSize:    'var(--navbar-text-size)',
          fontWeight:  'var(--navbar-text-fw)',
          marginRight: 'var(--navbar-text-spacing)',
        },

        // Desktop phone
        '.navbar-phone': {
          color:      'var(--navbar-phone-text-color)',
          fontSize:   'var(--navbar-phone-text-size)',
          fontWeight: 'var(--navbar-phone-text-fw)',
        },
        '.navbar-phone-transparent': {
          color:      'var(--navbar-phone-text-transparent)',
          fontSize:   'var(--navbar-phone-text-size)',
          fontWeight: 'var(--navbar-phone-text-fw)',
        },
        '.navbar-phone-hover': {
          color:      'var(--navbar-phone-text-hover-color)',
          fontSize:   'var(--navbar-phone-text-size)',
          fontWeight: 'var(--navbar-phone-text-fw)',
        },
        '.navbar-phone-transparent-hover': {
          color:      'var(--navbar-phone-text-hover-transparent)',
          fontSize:   'var(--navbar-phone-text-size)',
          fontWeight: 'var(--navbar-phone-text-fw)',
        },

        // Language selector
        '.language-selector':             { borderColor: 'var(--navbar-text-color)' },
        '.language-selector-transparent': { borderColor: 'var(--navbar-text-color-transparent)' },

        // Mobile nav links
        '.navbarmobiletext': {
          color:       'var(--navbar-mobile-text-color)',
          fontSize:    'var(--navbar-mobile-text-size)',
          fontWeight:  'var(--navbar-mobile-text-fw)',
          marginRight: 'var(--navbar-mobile-text-spacing)',
        },
        '.navbarmobiletext-transparent': {
          color:       'var(--navbar-text-mobile-color-transparent)',
          fontSize:    'var(--navbar-mobile-text-size)',
          fontWeight:  'var(--navbar-mobile-text-fw)',
          marginRight: 'var(--navbar-mobile-text-spacing)',
        },

        // Mobile phone
        '.navbar-mobile-phone': {
          color:       'var(--navbar-mobile-phone-color)',
          fontSize:    'var(--navbar-mobile-phone-size)',
          fontWeight:  'var(--navbar-mobile-phone-fw)',
        },
        '.navbar-mobile-phone-transparent': {
          color:       'var(--navbar-mobile-phone-color-transparent)',
          fontSize:    'var(--navbar-mobile-phone-size)',
          fontWeight:  'var(--navbar-mobile-phone-fw)',
        },

        // Burger
        '.navbar-burger': {
          borderColor:  'var(--navbar-mobile-burger-color)',
          borderRadius: 'var(--navbar-mobile-burger-radius)',
        },
        '.navbar-burger-close': {
          borderColor:  'var(--navbar-mobile-burger-close-color)',
          borderRadius: 'var(--navbar-mobile-burger-radius)',
        },

        // ── Footer ─────────────────────────────────────────────────────────────
        '.footer-container':    { background:  'var(--footer-bg-color)' },
        '.footer-company': {
          color:      'var(--footer-company-text-color)',
          fontSize:   'var(--footer-company-text-size)',
          fontWeight: 'var(--footer-company-text-fw)',
          gap:        'var(--footer-company-text-spacing)',
        },
        '.footer-section':      { gap: 'var(--footer-section-spacing)' },
        '.footer-section-title': {
          color:      'var(--footer-section-title-color)',
          fontSize:   'var(--footer-section-title-size)',
          fontWeight: 'var(--footer-section-title-fw)',
        },
        '.footer-section-link': {
          color:      'var(--footer-section-link-color)',
          fontSize:   'var(--footer-section-link-size)',
          fontWeight: 'var(--footer-section-link-fw)',
        },
        '.footer-copyright-text': {
          borderTopWidth: '1px',
          borderTopColor: 'var(--footer-copyright-text-color)',
          color:          'var(--footer-copyright-text-color)',
          fontSize:       'var(--footer-copyright-text-size)',
        },

        // ── Misc ───────────────────────────────────────────────────────────────
        '.card-unliked': {
          position:        'absolute',
          display:         'flex',
          flexDirection:   'row',
          flexWrap:        'wrap',
          top:             '0.25rem',
          right:           '0.25rem',
          zIndex:          '40',
          height:          '2rem',
          width:           '2rem',
          justifyContent:  'center',
          alignItems:      'center',
          borderWidth:     '1px',
          borderColor:     theme('colors.price'),
          borderRadius:    '0.375rem',
          padding:         '0.25rem',
        },
        '.card-liked': {
          position:       'absolute',
          display:        'flex',
          flexDirection:  'row',
          flexWrap:       'wrap',
          top:            theme('spacing.1'),
          right:          theme('spacing.1'),
          zIndex:         40,
          height:         theme('spacing.8'),
          width:          theme('spacing.8'),
          justifyContent: 'center',
          alignItems:     'center',
          borderWidth:    '1px',
          color:          theme('colors.price'),
          borderColor:    theme('colors.price'),
          borderRadius:   theme('borderRadius.md'),
          padding:        theme('spacing.1'),
        },
        '.transport-label-container': {
          position:      'absolute',
          display:       'flex',
          flexDirection: 'row',
          flexWrap:      'wrap',
          bottom:        theme('spacing.1'),
          left:          theme('spacing.1'),
        },
        '.transport-label': {
          color:        theme('colors.light'),
          borderRadius: theme('borderRadius.md'),
          padding:      theme('spacing.1'),
          marginLeft:   theme('spacing.1'),
          marginBottom: theme('spacing.1'),
        },
        '.large-card-image': {
          '@screen sm': { width: '300px' },
          width:       '100%',
          objectFit:   'cover',
          aspectRatio: '3 / 2',
          borderRadius:'var(--property-image-container-border-radius)',
          overflow:    'hidden',
        },
        '.form-label': { fontSize: theme('fontSize.sm') },
        '.btn': {
          width:         '100%',
          borderRadius:  theme('borderRadius.md'),
          padding:       theme('spacing.2'),
          color:         theme('colors.light'),
          fontWeight:    theme('fontWeight.bold'),
          // fontFamily:    theme('fontFamily.montserrat'),
          letterSpacing: theme('letterSpacing.wide'),
        },
        '.submit-btn': {
          color:           theme('colors.white'),
          backgroundColor: theme('colors.price'),
        },
        '.submit-btn:hover': {
          backgroundColor: theme('colors.price'),
        },
        '.round-style':   { borderRadius: theme('borderRadius.lg') },
        '.gradient-aurix': {
          backgroundImage:      'linear-gradient(to right, #CAA134, #B3852F, #D7B037, #9C6E18, #BE8B3C)',
          backgroundClip:       'text',
          WebkitBackgroundClip: 'text',
          color:                'transparent',
          WebkitTextFillColor:  'transparent',
        },
        '.infocard': {
          borderRadius: theme('borderRadius.lg'),
          borderWidth:  '1px',
          borderColor:  theme('colors.forth'),
          padding:      '1rem',
        },

      })
    }),
  ],
}